/**
 * Returns a display name for a user
 */
export default function (user) {
  return user?.displayName || ''
}
